/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Empty_Onboarding_BodyInputs */

const cs_chat_empty_onboarding_body = /** @type {(inputs: Chat_Empty_Onboarding_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte vlákno v seznamu vlevo, nebo založte novou konverzaci s kolegou.`)
};

const en_chat_empty_onboarding_body = /** @type {(inputs: Chat_Empty_Onboarding_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a thread in the list on the left, or start a new conversation with a teammate.`)
};

/**
* | output |
* | --- |
* | "Pick a thread in the list on the left, or start a new conversation with a teammate." |
*
* @param {Chat_Empty_Onboarding_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_empty_onboarding_body = /** @type {((inputs?: Chat_Empty_Onboarding_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Empty_Onboarding_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_empty_onboarding_body(inputs)
	return cs_chat_empty_onboarding_body(inputs)
});